<script>
  import { onMount } from "svelte";
  import ProductsTable from "./ProductsTable.svelte";
  import ProductCategories from "./ProductCategories.svelte";
  import Searchbox from "../../Common/Searchbox.svelte";
  import Dropdown from "../../Common/Dropdown.svelte";
  import { getStoreCategories } from "../../Common/tools";
  import {External, M} from "../../external";

  export let options = null;

  let instance = null;
  let tab = "products";
  let tableDetails = {
    count: 0,
    label: ""
  };
  let searchPhrase = "";
  let categories = [
    {
      name: M.ALL_CATEGORIES,
      id: -1
    }
  ];
  let activeCategory = categories[0];

  let onFilterChange = () => {
    setTimeout(() => {
      instance.reload();
    }, 1);
  };

  let changeTab = (newTab) => {
    tab = newTab;
  };

  let onTableLoaded = (event) => {
    let details = event.detail || {};
    tableDetails = {
      count: details.count || 0,
      label: details.label || ""
    };
  };

  let showMoreOptions = (event) => {
    const items = [
      {
        icon: "fa-upload",
        text: M.IMPORT,
        tag: "import"
      },
      {
        icon: "fa-trash",
        text: M.DELETE_SELECTED,
        tag: "delete"
      }
    ];

    External.Tools.showTooltipOptions(External.$(event.target), items, function (target, idx, text, tag) {
      switch (tag) {
        case "import":
          External.CSVProductsImporter().start();
          break;
        case "delete":
          instance.deleteSelected();
          break;
      }
    });
  };

  let showSearch = (event) => {
    External.Tools.showFloatingPopup({
      markup: '<div class="col20 f-left bound-popup"></div>',
      width: 250,
      target: External.$(event.target),
      customClass: "floating-popup-list",
      action: {
        onShow: function (popup, ui) {
          let component = new Searchbox({
            target: ui.find(".bound-popup")[0],
            props: {
              term: searchPhrase,
              onSearch: function (term) {
                searchPhrase = term;
                onFilterChange();
              }
            }
          });
          popup.component = component;
        },
        onHide: function (popup) {
          if (popup.component) {
            popup.component.$destroy();
            popup.component = null;
          }
        }
      }
    });
  };

  let clearSearch = () => {
    searchPhrase = "";
    onFilterChange();
  };

  let addProduct = () => {
    instance.onAddProduct();
  };

  let onCategoriesChanged = (event) => {
    categories = [
      {
        name: M.ALL_CATEGORIES,
        id: -1
      },
      ...event.detail.categories
    ];
    activeCategory = categories[0];
  };

  let onCategoryChanged = (event) => {
    activeCategory = event.detail.selected;
    onFilterChange();
  };

  onMount(async () => {
    let cats = await getStoreCategories(0);
    categories.push(...cats);
  });
</script>

<div class="account-settings overflow store-products flex-1 horizontal-flex-table col20" style="font-family: 'Roboto';">
  <div class="top-background-wrapper narrow-top-background">
    <div class="top-background">
      <div class="text-wrapper f-left col20 flex align-center space-between">
        <div class="flex-centered flex-col-mobile f-left flex" style="display: flex;">
          {#if tab === "products"}
            <h2 class="crm-title f-left crm-title-bigger">{tableDetails.count} {tableDetails.count === 1 ? M.PRODUCT : M.PRODUCTS}</h2>
            <h4 class="ml-15 hide-mobile" style="color: #fff;">in</h4>
            <Dropdown items={categories} activeItem={activeCategory} on:change={onCategoryChanged} class="ml-15" />
          {:else if tab === "categories"}
            <h2 class="crm-title f-left crm-title-bigger mb-10">{M.CATEGORIES}</h2>
          {/if}
        </div>
        <div class="f-right flex-centered">
          {#if tab === "products"}
            <div class="flex align-center search-inline-wrapper mobile-hidden">
              {#if searchPhrase}
                <a on:click={clearSearch} class="remove-search-btn flex align-center mr-5 rounded-effect">
                  <p class="f-left">{M.CLEAR}</p>
                  <p class="material-icons-outlined ml-5 f-left">cancel</p>
                </a>
              {/if}
              <a on:click={(event) => showSearch(event)} class="circle-button blue rounded-effect flex align-center justify-center">
                <span class="material-icons-outlined">search</span>
              </a>
            </div>
            <a on:click={addProduct} class="f-left middle-button color-default rounded-effect with-icon ml-5 blue" style="height:39px; line-height:39px;">{M.ADD_PRODUCT}</a>
            <a class="crm-option ml-5" on:click={(ev) => showMoreOptions(ev)} style="padding-right: 33px;">
              {M.MORE}
              <svg class="interface-icon o__standard" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 16 16">
                <path d="M4 6l4 4 4-4H4z" />
              </svg>
            </a>
          {/if}
        </div>
      </div>
    </div>
  </div>
  <div class="content-wrapper horizontal-flex-table">
    <div class="sections-wrapper members-wrapper horizontal-flex-table">
      <div class="section-bg members-wrapper products-wrapper crm-table-outer">
        <ul class="upper-navigation upper-navigation-full mb-15 mt-15">
          <li><a class:active={tab === "products"} on:click|preventDefault={() => changeTab("products")}>{M.PRODUCTS}</a></li>
          <li><a class:active={tab === "categories"} on:click|preventDefault={() => changeTab("categories")}>{M.CATEGORIES}</a></li>
        </ul>

        {#if tab === "products"}
          <ProductsTable bind:this={instance} category={activeCategory} search={searchPhrase} on:itemsloaded={onTableLoaded} />
        {:else if tab === "categories"}
          <ProductCategories bind:this={instance} on:root-categories-changed={onCategoriesChanged} />
        {/if}
      </div>
    </div>
  </div>
</div>
